import React from "react";
import { useOffline } from "../hooks/useOffline";

function OfflineBanner() {
  const isOffline = useOffline();
  if (!isOffline) return null;

  return (
    <div style={{
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      background: "#1e293b",
      color: "#f8fafc",
      padding: "0.6rem 1.25rem",
      display: "flex",
      alignItems: "center",
      gap: "0.6rem",
      fontSize: "0.85rem",
      fontFamily: "sans-serif",
      boxShadow: "0 -2px 8px rgba(0,0,0,0.2)",
    }}>
      <span style={{ fontSize: "1rem" }}>📶</span>
      <span>You are offline. Viewing cached data — changes cannot be saved until you reconnect.</span>
    </div>
  );
}

export default OfflineBanner;
